import {Component}              from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatSnackBar}            from '@angular/material/snack-bar';
import {ApiService}             from '@src/app/shared/services/api.service';

@Component({
    selector: 'app-system-settings',
    templateUrl: './system-settings.component.html',
})
export class SystemSettingsComponent
{
    public systemSettingsForm: FormGroup = new FormGroup({
        tenant: new FormGroup({
            timezone: new FormControl('')
        }),
        credits: new FormGroup({
            low_credit_warning: new FormControl<number>(0)
        }),
    });

    get form()
    {
        return this.systemSettingsForm.controls;
    }

    constructor(
        private apiService: ApiService,
        private snackBar: MatSnackBar
    )
    {
        this.apiService.list('settings').subscribe({
            next: response => {
                this.form.credits.get('low_credit_warning').setValue(response.data.find(c => c.name == 'low_credit_warning').value);
            },
            error: error => this.apiService.handleError(error)
        });
    }

    public submitCredits()
    {
        if (this.form.credits.valid) {
            this.apiService.updateSettings('settings/credits', this.form.credits.value).subscribe({
                next: response => {
                    this.form.credits.get('low_credit_warning').setValue(response.data.find(c => c.name == 'low_credit_warning').value);
                    this.snackBar.open('You have successfully updated the credits settings.', 'Ok', {duration: 2500});
                },
                error: error => this.apiService.handleError(error)
            });
        } else {
            this.snackBar.open('Please ensure all inputs for the credits section are filled out correctly.', 'Ok', {duration: 2500});
        }
    }
}
